import { useEffect, useRef, useState } from 'react';

const useMultilineEllipsisDetection = () => {
  const ref = useRef<HTMLElement>(null);
  const [hasEllipsis, setHasEllipsis] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const checkEllipsis = () => {
      const isTruncated = element.scrollHeight > element.clientHeight + 10;
      setHasEllipsis(isTruncated);
    };

    checkEllipsis();
    window.addEventListener('resize', checkEllipsis);

    return () => window.removeEventListener('resize', checkEllipsis);
  }, []);

  return { ref, hasEllipsis };
};

export default useMultilineEllipsisDetection;
